import { CheckCircleIcon, AlertCircleIcon } from '@/components/ui/icons';

/**
 * Inline success message.
 * @param {{ children: React.ReactNode }} props
 */
export function SuccessMessage({ children }) {
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md border border-success/20 bg-success-surface p-3 text-sm text-text-primary"
    >
      <CheckCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" />
      <div>{children}</div>
    </div>
  );
}

/**
 * Inline error message with alert role.
 * @param {{ children: React.ReactNode }} props
 */
export function ErrorMessage({ children }) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-md border border-error/20 bg-error-surface p-3 text-sm text-text-primary"
    >
      <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-error" />
      <div>{children}</div>
    </div>
  );
}